module.exports = {"pageTitle":"Notice","version":"Version","event":"Event","checking":"Checking","operator":"Operator","notEntered":"Not entered","dateNotEntered":"Date: Not entered","target":"Target","views":"Views","status":"Status","editButton":"Edit","active":"Active","inactive":"Inactive","golfClubCount":"Golf Club ({n})","replyAlert1":"Registering a reply will send","replyAlert2":"a notification to the inquirer.","replyAlert3":"Do you want to register it?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs002.json
// module id = XLXH
// module chunks = 2